import { useEffect, useState } from 'react';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import { View } from 'foundations-components/components/View';
// @ts-expect-error no types from package
import Cookies from 'js-cookie';
import { NavMarker } from 'react-rhumb';
import IE11Alert from 'LoginUI/components/alerts/IE11Alert';
import LegacyLoginL from 'LoginUI/components/alerts/LegacyLoginLink';
import ErrorMessage from 'LoginUI/components/alerts/ErrorMessage';
import SmartLoginEntryForm from './SmartLoginEntryForm';
import SmartLoginOptionColumn from './SmartLoginOptionColumn';
import LoginLoading from 'LoginUI/components/LoginLoading';
import AppLogo from 'LoginUI/components/AppLogo';
import SignupLink from 'LoginUI/components/legacyLogins/shared/SignupLink';
import MarketingCta from './MarketingCta';
import { useLoginLandingPage } from './useLoginLandingPage';
import { SmartLoginLandingPageContext } from './SmartLoginLandingPageContext';
import { trackSmartLoginLoad } from 'LoginUI/lib/tracker';
import { SMART_LOGIN_COOKIE } from 'LoginUI/constants/SmartLogin';
import { getIsChatSpot, getIsConnect, getIsCalendarConnect } from 'LoginUI/utils/urls';
import { useIsMobileLogin } from 'LoginUI/context/MobileLoginContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SmartLoginLandingPage = () => {
  const contextValue = useLoginLandingPage();
  const {
    error,
    isFbSignin,
    loginRedirectUrl,
    sessionInvalidationWarning,
    signupParams,
    signupUrl,
    pageId,
    isBypassChecked
  } = contextValue;
  const [showMarketingCta, setShowMarketingCta] = useState(false);

  // Send tracking request on page load
  useEffect(() => {
    trackSmartLoginLoad('control');
  }, []);
  const isMobileLogin = useIsMobileLogin();
  useEffect(() => {
    if (Cookies.get(SMART_LOGIN_COOKIE) || Cookies.get('hs_selenium') || getIsCalendarConnect() || isMobileLogin) {
      setShowMarketingCta(false);
    } else {
      setShowMarketingCta(true);
    }
  }, [isMobileLogin]);
  const isChatSpot = getIsChatSpot();
  const isConnect = getIsConnect();
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "LOGIN_LOAD",
    children: isBypassChecked ? /*#__PURE__*/_jsx(SmartLoginLandingPageContext.Provider, {
      value: contextValue,
      children: /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsxs(Flex, {
          alignSelf: "center",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          children: [/*#__PURE__*/_jsx(View, {
            maxInlineSize: "450px",
            inlineSize: "100%",
            children: /*#__PURE__*/_jsx(AppLogo, {
              logoWidth: "180px",
              logoAlignment: "center",
              logoPadding: "800",
              children: /*#__PURE__*/_jsx(SignupLink, {
                isFbSignin: isFbSignin,
                signupParams: signupParams || '',
                loginRedirectUrlQueryParam: loginRedirectUrl,
                pageId: pageId
              })
            })
          }), !isChatSpot && !isConnect && /*#__PURE__*/_jsx(LegacyLoginL, {}), /*#__PURE__*/_jsxs(View, {
            maxInlineSize: "1300px",
            inlineSize: "100%",
            paddingBlockEnd: "1400",
            paddingBlockStart: "400",
            children: [/*#__PURE__*/_jsxs(Flex, {
              flexBasis: "row",
              flexWrap: "wrap",
              justifyContent: "space-between",
              children: [/*#__PURE__*/_jsx(Box, {
                basis: 500,
                shrink: 1,
                grow: 1,
                children: /*#__PURE__*/_jsxs(TFlex, {
                  align: "center",
                  justify: "center",
                  direction: "column",
                  children: [/*#__PURE__*/_jsxs(View, {
                    maxInlineSize: "450px",
                    inlineSize: "100%",
                    children: [/*#__PURE__*/_jsx(IE11Alert, {}), /*#__PURE__*/_jsx(ErrorMessage, {
                      error: error || sessionInvalidationWarning,
                      type: error ? 'danger' : 'info',
                      prefix: error ? 'login.errors' : 'login.warnings',
                      signUpLink: signupUrl
                    })]
                  }), /*#__PURE__*/_jsx(SmartLoginEntryForm, {})]
                })
              }), /*#__PURE__*/_jsx(Box, {
                basis: 500,
                shrink: 1,
                grow: 1,
                children: /*#__PURE__*/_jsx(View, {
                  borderInlineStartStyle: "solid",
                  borderInlineStartColor: "border-core-default",
                  children: /*#__PURE__*/_jsx(TFlex, {
                    align: "center",
                    justify: "center",
                    direction: "column",
                    children: /*#__PURE__*/_jsx(SmartLoginOptionColumn, {})
                  })
                })
              })]
            }), showMarketingCta && /*#__PURE__*/_jsx(MarketingCta, {})]
          })]
        })
      })
    }) : /*#__PURE__*/_jsx(LoginLoading, {})
  });
};
export default SmartLoginLandingPage;